/* prequal interface start */
export interface PrequalAddon {
  key: string;
  name: string;
  restricted: boolean;
  supports: string[];
  planDetails: PrequalAddonPlanDetail[] | null;
}
export interface PrequalAddonPlanDetail {
  key: string;
  description: string;
  chargeExcludingGst: number;
  chargeIncludingGst: number;
  billFrequency: string;
  unit: string;
  freeSecondsPerCall: number | null;
  destinations: any[];
}

export interface PrequalAvailableProduct {
  service: string;
  details: PrequalDetail[];
}
export interface PrequalComponentPlanDetail {
  key: string;
  description: string;
  chargeExcludingGst: number;
  chargeIncludingGst: number;
  billFrequency: string;
  unit: string;
  dataCap: null;
  dataBanking: boolean | null;
  dataRollover: boolean | null;
  minimumContractTerm: number;
}

export interface PrequalComponent {
  service?: string;
  planDetails?: PrequalComponentPlanDetail[];
  productComponentService?: string;
  productComponentPlans?: any[];
}
export interface PrequalDetail {
  key?: string;
  description?: string;
  category?: string;
  supplier?: string;
  categoryGroup?: string | null;
  voiceCategory?: string;
  components?: PrequalComponent[];
  service?: string;
  details?: PrequalDetail[];
}
export interface PrequalHardware {
  make: string;
  model: string;
  type: string;
  planDetails: PrequalHardwarePlanDetail[];
}

export interface PrequalHardwarePlanDetail {
  key: string;
  description?: string;
  chargeExcludingGst: number;
  chargeIncludingGst: number;
  purchaseType: string;
  hardwareProductDescription?: string;
  hardwareProductExtendedDescription?: string;
  hardwareProductMake?: string;
  hardwareProductModel?: string;
  hardwareProductType?: string;
  categoriesSupported?: string[];
  voiceProductVoiceCategories?: any[] | null;
  availableTo?: any[] | null;
}
export interface PrequalFibreSummary {
  fibreAvailable: boolean;
  fibreInstalled: boolean;
  fibreActive: boolean;
  consentRequired: boolean;
  consentStatus: string;
  rightOfWay: boolean;
  buildingType: string;
  fibreEta?: Date;
  fibreInADay: boolean;
  locationId: string;
}

export interface Prequal {
  availableProducts: PrequalAvailableProduct[];
  addOns: PrequalAddon[];
  hardware: PrequalHardware[];
  fibreSummary: PrequalFibreSummary;
  fibreDetails: any;
}

export type BBPlanIndex =
  | 0 // fibre pro
  | 1 // fibre every
  | 2; //fibre starter

export enum FibreCompanies {
  Chorus = 'ChorusNGA',
  Enable = 'Enable',
  NorthPower = 'NorthPower',
  UFF = 'UFF',
}

export type ConnectionType = 'Migrate' | 'New' | 'Connect';

export interface DetailAddons {
  type: 'modem' | 'mesh' | 'static_ip' | 'plan';
  productId: string;
  ratePlan?: string;
}
/* prequal interface end */
